import debounce from "lodash/debounce";

export const initResizeListener = (action) => {
  window.addEventListener("resize", debounce(action, 200));
};
